import { Box, Button, Typography, styled, keyframes } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Animasi bounce untuk 404
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-20px); }
  60% { transform: translateY(-10px); }
`;

const Root = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  width: '100%',
  backgroundColor: '#fff0f0', // soft red background
}));

const Container = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  maxWidth: 400,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
}));

const Animated404 = styled(Typography)(() => ({
  fontSize: '6rem',
  fontWeight: 900,
  color: '#d32f2f', // MUI danger color
  animation: `${bounce} 2s infinite`,
}));

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <Root>
      <Container>
        <Animated404>404</Animated404>
        <Typography variant="h5" gutterBottom fontWeight={600} color="error">
          Oops! Page Not Found
        </Typography>
        <Typography variant="body1" color="textSecondary" mb={3}>
          The page you are looking for might have been removed or is temporarily unavailable.
        </Typography>
        <Button
          variant="contained"
          color="error"
          onClick={handleGoBack}
          sx={{ textTransform: 'capitalize', px: 4, py: 1.5 }}
        >
          Go Back
        </Button>
      </Container>
    </Root>
  );
};

export default NotFound;
